/**
 * Open-redirect guard for the `?redirect=` the login flow carries.
 * Only same-origin absolute paths survive, and never back to /login itself.
 */
export function validateRedirectUrl(url: string | undefined): string | null {
  if (!url) return null;
  if (url === '/login') return null;
  if (url.startsWith('//')) return null;          // protocol-relative
  if (url.includes('://')) return null;
  if (url.startsWith('/')) return url;
  return null;
}
